module.exports = "/_next/static/images/Hero@2x-990ca9a7cb047883c1d51d02f32b7973.webp";